module.exports = __webpack_public_path__ + "img/level1-expl.da56cf42.png";